module.exports = __webpack_public_path__ + "static/media/Mask Group 31.7a1b33f1.png";